import {OrderStatus} from '../types';

export default (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.awaiting_payment:
      return 'Aguardando pagamento';
    case OrderStatus.opened:
      return 'Aberto';
    case OrderStatus.preparing:
      return 'Em preparo';
    case OrderStatus.ready_to_pickup:
      return 'Pronto para Retirada';
    case OrderStatus.ready_to_delivery:
      return 'Pronto para Entrega';
    case OrderStatus.delivering:
      return 'Em Entrega';
    case OrderStatus.arrival:
      return 'Chegou no endereço';
    case OrderStatus.delivery_man_assigned:
      return 'Entregador vinculado';
    case OrderStatus.delivery_man_auto_assigned:
      return 'Entregador pegou pedido';
    case OrderStatus.finished:
      return 'Finalizado';
    case OrderStatus.canceled:
      return 'Cancelado';
    default:
      return 'Status Desconhecido';
  }
};
